module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.7fab42ac.png";